module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }]
  }, [_c('div', {
    attrs: {
      "id": "neirong"
    }
  }, [_c('div', {
    staticClass: "cbo",
    staticStyle: {
      "margin-top": "90px",
      "font-size": "23px",
      "color": "red"
    }
  }, [_vm._v(" \n           注：以下红色项为必填项\n         ")]), _vm._v(" "), _c('div', {
    staticClass: "cbo",
    staticStyle: {
      "margin-top": "10px",
      "font-size": "23px",
      "margin-bottom": "-30px"
    }
  }, [_vm._v("  1. 委托人Client \n            "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-right": "5%"
    }
  }, [_vm._v("合同编号：" + _vm._s(_vm.data.serialNumber))])]), _vm._v(" "), _c('div', {
    staticClass: "cbo"
  }, [_c('table', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("名称Name：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.clientName),
      expression: "data.clientName"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly,
      "size": "medium"
    },
    domProps: {
      "value": (_vm.data.clientName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "clientName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("地址Address：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.clientAddr),
      expression: "data.clientAddr"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.clientAddr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "clientAddr", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "color"
  }, [_vm._v("联系人Contact：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.clientContacts),
      expression: "data.clientContacts"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.clientContacts)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "clientContacts", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "color"
  }, [_vm._v("电话Phone：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.clientPhone),
      expression: "data.clientPhone"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.clientPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "clientPhone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "color"
  }, [_vm._v("邮箱E-mail：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.clientMail),
      expression: "data.clientMail"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.clientMail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "clientMail", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("传真Fax："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.clientFax),
      expression: "data.clientFax"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.clientFax)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "clientFax", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "cbo",
    staticStyle: {
      "margin-top": "30px",
      "font-size": "23px",
      "margin-bottom": "-30px"
    }
  }, [_vm._v(" 2. 生产者（制造商）Manufacturer（ \n            "), _c('el-button', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.data.producerName = _vm.data.clientName;
        _vm.data.producerAddr = _vm.data.clientAddr;
        _vm.data.producerContacts = _vm.data.clientContacts;
        _vm.data.producerPhone = _vm.data.clientPhone;
        _vm.data.producerMail = _vm.data.clientMail;
        _vm.data.producerFax = _vm.data.clientFax;
      }
    }
  }, [_vm._v("同委托方")]), _vm._v("\n          ）\n       ")], 1), _vm._v(" "), _c('div', {
    staticClass: "cbo"
  }, [_c('table', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("名称Name： "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.producerName),
      expression: "data.producerName"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.producerName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "producerName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("地址Address："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.producerAddr),
      expression: "data.producerAddr"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.producerAddr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "producerAddr", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("联系人Contact："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.producerContacts),
      expression: "data.producerContacts"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.producerContacts)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "producerContacts", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("电话Phone："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.producerPhone),
      expression: "data.producerPhone"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.producerPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "producerPhone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("邮箱E-mail："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.producerMail),
      expression: "data.producerMail"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.producerMail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "producerMail", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("传真Fax："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.producerFax),
      expression: "data.producerFax"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.producerFax)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "producerFax", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "cbo",
    staticStyle: {
      "margin-top": "30px",
      "font-size": "23px",
      "margin-bottom": "-30px"
    }
  }, [_vm._v("  3. 生产企业Factory（ \n            "), _c('el-button', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.data.factoryName = _vm.data.clientName;
        _vm.data.factoryAddr = _vm.data.clientAddr;
        _vm.data.factoryContacts = _vm.data.clientContacts;
        _vm.data.factoryPhone = _vm.data.clientPhone;
        _vm.data.factoryMail = _vm.data.clientMail;
        _vm.data.factoryFax = _vm.data.clientFax;
      }
    }
  }, [_vm._v("同委托方")]), _vm._v("） ")], 1), _vm._v(" "), _c('div', {
    staticClass: "cbo"
  }, [_c('table', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("名称Name： "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.factoryName),
      expression: "data.factoryName"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.factoryName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "factoryName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("地址Address："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.factoryAddr),
      expression: "data.factoryAddr"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.factoryAddr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "factoryAddr", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("联系人Contact："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.factoryContacts),
      expression: "data.factoryContacts"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.factoryContacts)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "factoryContacts", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("电话Phone："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.factoryPhone),
      expression: "data.factoryPhone"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.factoryPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "factoryPhone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("邮箱E-mail："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.factoryMail),
      expression: "data.factoryMail"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.factoryMail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "factoryMail", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("传真Fax："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.factoryFax),
      expression: "data.factoryFax"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.factoryFax)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "factoryFax", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "cbo",
    staticStyle: {
      "margin-top": "30px",
      "font-size": "23px",
      "margin-bottom": "-30px"
    }
  }, [_vm._v("  4. 代理方Agent\t ")]), _vm._v(" "), _c('div', {
    staticClass: "cbo"
  }, [_c('table', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("名称Name： "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.agentName),
      expression: "data.agentName"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.agentName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "agentName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("地址Address："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.agentAddr),
      expression: "data.agentAddr"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.agentAddr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "agentAddr", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("联系人Contact："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.agentContacts),
      expression: "data.agentContacts"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.agentContacts)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "agentContacts", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("电话Phone："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.agentPhone),
      expression: "data.agentPhone"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.agentPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "agentPhone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("邮箱E-mail："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.agentMail),
      expression: "data.agentMail"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.agentMail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "agentMail", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("传真Fax："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.agentFax),
      expression: "data.agentFax"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.agentFax)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "agentFax", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "cbo",
    staticStyle: {
      "margin-top": "30px",
      "font-size": "23px",
      "margin-bottom": "-30px"
    }
  }, [_vm._v("  5. 交费方Payer（\n             "), _c('el-button', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.data.payerName = _vm.data.clientName;
        _vm.data.payerAddr = _vm.data.clientAddr;
        _vm.data.payerContacts = _vm.data.clientContacts;
        _vm.data.payerPhone = _vm.data.clientPhone;
        _vm.data.payerMail = _vm.data.clientMail;
        _vm.data.payerFax = _vm.data.clientFax;
      }
    }
  }, [_vm._v("同委托方")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.data.payerName = _vm.data.producerName;
        _vm.data.payerAddr = _vm.data.producerAddr;
        _vm.data.payerContacts = _vm.data.producerContacts;
        _vm.data.payerPhone = _vm.data.producerPhone;
        _vm.data.payerMail = _vm.data.producerMail;
        _vm.data.payerFax = _vm.data.producerFax;
      }
    }
  }, [_vm._v("同生产企业")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.data.payerName = _vm.data.agentName;
        _vm.data.payerAddr = _vm.data.agentAddr;
        _vm.data.payerContacts = _vm.data.agentContacts;
        _vm.data.payerPhone = _vm.data.agentPhone;
        _vm.data.payerMail = _vm.data.agentMail;
        _vm.data.payerFax = _vm.data.agentFax;
      }
    }
  }, [_vm._v("同代理方")]), _vm._v("\n           ） ")], 1), _vm._v(" "), _c('div', {
    staticClass: "cbo"
  }, [_c('table', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("名称Name：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.payerName),
      expression: "data.payerName"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.payerName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "payerName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("地址Address：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.payerAddr),
      expression: "data.payerAddr"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.payerAddr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "payerAddr", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "color"
  }, [_vm._v("联系人Contact：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.payerContacts),
      expression: "data.payerContacts"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.payerContacts)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "payerContacts", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "color"
  }, [_vm._v("电话Phone：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.payerPhone),
      expression: "data.payerPhone"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.payerPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "payerPhone", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "color"
  }, [_vm._v("邮箱E-mail：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.payerMail),
      expression: "data.payerMail"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.payerMail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "payerMail", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('td', [_vm._v("传真Fax："), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.payerFax),
      expression: "data.payerFax"
    }],
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.payerFax)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "payerFax", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "overflow": "visible"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v(" 付款方式：")]), _vm._v(" "), [_c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "1"
    },
    model: {
      value: (_vm.data.paymentMethod),
      callback: function($$v) {
        _vm.$set(_vm.data, "paymentMethod", $$v)
      },
      expression: "data.paymentMethod"
    }
  }, [_vm._v("汇款remittance")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "2"
    },
    model: {
      value: (_vm.data.paymentMethod),
      callback: function($$v) {
        _vm.$set(_vm.data, "paymentMethod", $$v)
      },
      expression: "data.paymentMethod"
    }
  }, [_vm._v("支票Check")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "3"
    },
    model: {
      value: (_vm.data.paymentMethod),
      callback: function($$v) {
        _vm.$set(_vm.data, "paymentMethod", $$v)
      },
      expression: "data.paymentMethod"
    }
  }, [_vm._v("其他Other：")])], _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.paymentMethodOrder),
      expression: "data.paymentMethodOrder"
    }],
    style: (_vm.inputStyle),
    attrs: {
      "size": "10",
      "readonly": (_vm.isRedeoly || _vm.data.paymentMethod !== '3')
    },
    domProps: {
      "value": (_vm.data.paymentMethodOrder)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "paymentMethodOrder", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "color"
  }, [_vm._v(" 收到《收费通知单》在 "), _c('el-date-picker', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "type": "date",
      "placeholder": "选择日期"
    },
    on: {
      "change": function($event) {
        _vm.data.payDate = _vm.initTime(_vm.data.payDate)
      }
    },
    model: {
      value: (_vm.data.payDate),
      callback: function($$v) {
        _vm.$set(_vm.data, "payDate", $$v)
      },
      expression: "data.payDate"
    }
  }), _vm._v(" 前或按合同约定时间内付款")], 1)], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "cbo",
    staticStyle: {
      "margin-top": "30px",
      "font-size": "23px",
      "overflow": "visible"
    }
  }, [_vm._v("  6. 样品信息Sample Information  ")]), _vm._v(" "), _c('div', {
    staticClass: "cbo"
  }, [_c('table', [_c('tr', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('th', {
    attrs: {
      "width": "8%"
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.data.subData.push({
          order: '',
          name: '',
          specs: '',
          trademark: '',
          number: ''
        })
      }
    }
  }, [_vm._v("添加样品信息")])], 1)]), _vm._v(" "), _vm._l((_vm.data.subData), function(item, i) {
    return _c('tr', {
      key: i
    }, [_c('td', [_vm._v(" " + _vm._s(_vm.data.subData[i].order = (i + 1)) + "  ")]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.data.subData[i].name),
        expression: "data.subData[i].name"
      }],
      staticStyle: {
        "width": "99%"
      },
      attrs: {
        "readonly": _vm.isRedeoly
      },
      domProps: {
        "value": (_vm.data.subData[i].name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.data.subData[i], "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.data.subData[i].specs),
        expression: "data.subData[i].specs"
      }],
      staticStyle: {
        "width": "99%"
      },
      attrs: {
        "readonly": _vm.isRedeoly
      },
      domProps: {
        "value": (_vm.data.subData[i].specs)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.data.subData[i], "specs", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.data.subData[i].kind),
        expression: "data.subData[i].kind"
      }],
      staticStyle: {
        "width": "99%"
      },
      attrs: {
        "readonly": _vm.isRedeoly
      },
      domProps: {
        "value": (_vm.data.subData[i].kind)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.data.subData[i], "kind", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.data.subData[i].describe),
        expression: "data.subData[i].describe"
      }],
      staticStyle: {
        "width": "99%"
      },
      attrs: {
        "readonly": _vm.isRedeoly
      },
      domProps: {
        "value": (_vm.data.subData[i].describe)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.data.subData[i], "describe", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.data.subData[i].trademark),
        expression: "data.subData[i].trademark"
      }],
      staticStyle: {
        "width": "99%"
      },
      attrs: {
        "readonly": _vm.isRedeoly
      },
      domProps: {
        "value": (_vm.data.subData[i].trademark)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.data.subData[i], "trademark", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.data.subData[i].number),
        expression: "data.subData[i].number"
      }],
      staticStyle: {
        "width": "99%"
      },
      attrs: {
        "readonly": _vm.isRedeoly,
        "placeholder": "请输入整数"
      },
      domProps: {
        "value": (_vm.data.subData[i].number)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.data.subData[i], "number", $event.target.value)
        }, function($event) {
          _vm.data.subData[i].number = _vm.data.subData[i].number.replace(/[^\d]/g, '')
        }]
      }
    })]), _vm._v(" "), _c('td', [_c('el-button', {
      attrs: {
        "disabled": _vm.isRedeoly,
        "type": "primary",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.data.subData.splice(i, 1)
        }
      }
    }, [_vm._v("删除")])], 1)])
  }), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v("    提供的配件或资料： "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.providePartsMaterial),
      expression: "data.providePartsMaterial"
    }],
    attrs: {
      "readonly": _vm.isRedeoly,
      "size": "100"
    },
    domProps: {
      "value": (_vm.data.providePartsMaterial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "providePartsMaterial", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "overflow": "visible"
    },
    attrs: {
      "colspan": "8"
    }
  }, [_vm._m(7), _vm._v(" "), [_c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "1"
    },
    model: {
      value: (_vm.data.simpleSubmitMethod),
      callback: function($$v) {
        _vm.$set(_vm.data, "simpleSubmitMethod", $$v)
      },
      expression: "data.simpleSubmitMethod"
    }
  }, [_vm._v("自送")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "2"
    },
    model: {
      value: (_vm.data.simpleSubmitMethod),
      callback: function($$v) {
        _vm.$set(_vm.data, "simpleSubmitMethod", $$v)
      },
      expression: "data.simpleSubmitMethod"
    }
  }, [_vm._v("邮寄")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "4"
    },
    model: {
      value: (_vm.data.simpleSubmitMethod),
      callback: function($$v) {
        _vm.$set(_vm.data, "simpleSubmitMethod", $$v)
      },
      expression: "data.simpleSubmitMethod"
    }
  }, [_vm._v("现场测试，无样交接")])]], 2)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "overflow": "visible",
      "padding": "10px",
      "line-height": "35px"
    },
    attrs: {
      "colspan": "8",
      "rowspan": "2"
    }
  }, [_vm._m(8), _vm._v(" \n                  "), [_c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "6"
    },
    model: {
      value: (_vm.data.sampleHandle),
      callback: function($$v) {
        _vm.$set(_vm.data, "sampleHandle", $$v)
      },
      expression: "data.sampleHandle"
    }
  }, [_vm._v("到付寄回\n                          "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.sampleHandle == '6'),
      expression: "data.sampleHandle=='6'"
    }]
  }, [_vm._v("（ \n                          "), [_c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "1"
    },
    model: {
      value: (_vm.data.sampleHandleReturn),
      callback: function($$v) {
        _vm.$set(_vm.data, "sampleHandleReturn", $$v)
      },
      expression: "data.sampleHandleReturn"
    }
  }, [_vm._v("同委托人 ")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "2"
    },
    model: {
      value: (_vm.data.sampleHandleReturn),
      callback: function($$v) {
        _vm.$set(_vm.data, "sampleHandleReturn", $$v)
      },
      expression: "data.sampleHandleReturn"
    }
  }, [_vm._v("同生产企业")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "3"
    },
    model: {
      value: (_vm.data.sampleHandleReturn),
      callback: function($$v) {
        _vm.$set(_vm.data, "sampleHandleReturn", $$v)
      },
      expression: "data.sampleHandleReturn"
    }
  }, [_vm._v("同代理方")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "4"
    },
    model: {
      value: (_vm.data.sampleHandleReturn),
      callback: function($$v) {
        _vm.$set(_vm.data, "sampleHandleReturn", $$v)
      },
      expression: "data.sampleHandleReturn"
    }
  }, [_vm._v("同交费方")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "5"
    },
    model: {
      value: (_vm.data.sampleHandleReturn),
      callback: function($$v) {
        _vm.$set(_vm.data, "sampleHandleReturn", $$v)
      },
      expression: "data.sampleHandleReturn"
    }
  }, [_vm._v("其他")])], _vm._v(" "), (_vm.data.sampleHandleReturn == '5') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.sampleHandleReturnOther),
      expression: "data.sampleHandleReturnOther"
    }],
    style: (_vm.sampleHandleReturnOtherStyle),
    attrs: {
      "size": "60",
      "readonly": (_vm.isRedeoly || _vm.data.sampleHandleReturn !== '5')
    },
    domProps: {
      "value": (_vm.data.sampleHandleReturnOther)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "sampleHandleReturnOther", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" \n                          ）\n                          ")], 2)]), _c('br'), _vm._v("\n                         "), _c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "2"
    },
    model: {
      value: (_vm.data.sampleHandle),
      callback: function($$v) {
        _vm.$set(_vm.data, "sampleHandle", $$v)
      },
      expression: "data.sampleHandle"
    }
  }, [_vm._v("合同完成后一个月内自取（超期视为主动弃置，按销毁处置）")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "3"
    },
    model: {
      value: (_vm.data.sampleHandle),
      callback: function($$v) {
        _vm.$set(_vm.data, "sampleHandle", $$v)
      },
      expression: "data.sampleHandle"
    }
  }, [_vm._v("实验室销毁")])]], 2)]), _vm._v(" "), _c('tr')], 2)]), _vm._v(" "), _c('div', {
    staticClass: "cbo",
    staticStyle: {
      "margin-top": "30px",
      "font-size": "23px",
      "margin-bottom": "-30px"
    }
  }, [_vm._v(" 7. 检验检测要求Inspection and Testing Requirements\t ")]), _vm._v(" "), _c('div', {
    staticClass: "cbo",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('table', [_c('tr', [_vm._m(9), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "3800",
      "readonly": _vm.isRedeoly,
      "type": "textarea",
      "autosize": {
        minRows: 4,
        maxRows: 4
      }
    },
    model: {
      value: (_vm.data.basis),
      callback: function($$v) {
        _vm.$set(_vm.data, "basis", $$v)
      },
      expression: "data.basis"
    }
  })], 1)]), _vm._v(" "), _c('tr'), _vm._v(" "), _c('tr', [_vm._m(10), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "3800",
      "readonly": _vm.isRedeoly,
      "type": "textarea",
      "autosize": {
        minRows: 4,
        maxRows: 4
      }
    },
    model: {
      value: (_vm.data.items),
      callback: function($$v) {
        _vm.$set(_vm.data, "items", $$v)
      },
      expression: "data.items"
    }
  })], 1)]), _vm._v(" "), _c('tr'), _vm._v(" "), _c('tr', [_vm._m(11), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "3800",
      "readonly": _vm.isRedeoly,
      "type": "textarea",
      "autosize": {
        minRows: 4,
        maxRows: 4
      }
    },
    model: {
      value: (_vm.data.conditionsRequirements),
      callback: function($$v) {
        _vm.$set(_vm.data, "conditionsRequirements", $$v)
      },
      expression: "data.conditionsRequirements"
    }
  })], 1)]), _vm._v(" "), _c('tr'), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "overflow": "visible"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("如需分包：")]), _vm._v(" "), [_c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "1"
    },
    model: {
      value: (_vm.data.agreeSubcontract),
      callback: function($$v) {
        _vm.$set(_vm.data, "agreeSubcontract", $$v)
      },
      expression: "data.agreeSubcontract"
    }
  }, [_vm._v("同意")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "0"
    },
    model: {
      value: (_vm.data.agreeSubcontract),
      callback: function($$v) {
        _vm.$set(_vm.data, "agreeSubcontract", $$v)
      },
      expression: "data.agreeSubcontract"
    }
  }, [_vm._v("不同意")])]], 2), _vm._v(" "), _c('td', {
    staticStyle: {
      "overflow": "visible"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("该检验是否与诉讼有关：")]), _vm._v(" "), [_c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "0"
    },
    model: {
      value: (_vm.data.lawsuit),
      callback: function($$v) {
        _vm.$set(_vm.data, "lawsuit", $$v)
      },
      expression: "data.lawsuit"
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "1"
    },
    model: {
      value: (_vm.data.lawsuit),
      callback: function($$v) {
        _vm.$set(_vm.data, "lawsuit", $$v)
      },
      expression: "data.lawsuit"
    }
  }, [_vm._v(" 是（按诉讼委托流程进行）")])]], 2)]), _vm._v(" "), _c('tr', [_vm._m(12), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [(!_vm.isRedeoly) ? _c('div', {
    staticStyle: {
      "float": "left",
      "width": "350px",
      "padding": "20px",
      "text-align": "left"
    }
  }, [_c('el-upload', {
    attrs: {
      "action": "https://127.0.0.1/posts/",
      "on-remove": _vm.removeFile,
      "multiple": "",
      "before-upload": _vm.beforeAvatarUpload,
      "http-request": _vm.upload,
      "limit": 10
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v("选取文件")]), _c('br')], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "padding": "20px",
      "text-align": "left",
      "width": "90%"
    }
  }, _vm._l((_vm.data.attachMent), function(item, i) {
    return _c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.type !== 'delete'),
        expression: "item.type!=='delete'"
      }],
      key: i,
      staticClass: "el-upload-list__item-name",
      staticStyle: {
        "font-size": "15px",
        "padding-top": "0px",
        "float": "left"
      }
    }, [_c('div', {
      staticStyle: {
        "float": "left",
        "width": "300px",
        "overflow": "hidden",
        "white-space": "nowrap",
        "text-overflow": "ellipsis"
      }
    }, [_c('span', [_c('el-tooltip', {
      staticClass: "item",
      attrs: {
        "effect": "dark",
        "content": item.fileName,
        "placement": "bottom"
      }
    }, [_c('i', {
      staticClass: "el-icon-document",
      staticStyle: {
        "color": "blue"
      }
    }, [_vm._v(" " + _vm._s(item.fileName))])])], 1)]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "left",
        "font-size": "20px"
      }
    }, [_c('span', [_c('a', {
      attrs: {
        "href": "https://fw.ceprei.com/service/conSgin/downFile?fileId=" + item.fileId + "&fileName=" + item.fileName
      }
    }, [_c('i', {
      staticClass: "el-icon-download",
      staticStyle: {
        "color": "#32cd32"
      }
    })])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "float": "left",
        "font-size": "20px"
      }
    }, [(!_vm.isRedeoly) ? _c('span', [_c('span', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteFile(item)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-circle-close",
      staticStyle: {
        "color": "red"
      }
    })])]) : _vm._e()])])
  }), 0)])]), _vm._v(" "), _c('tr')])])]), _vm._v(" "), _c('div', {
    staticClass: "divcenter",
    staticStyle: {
      "margin-top": "30px",
      "font-size": "23px",
      "float": "right",
      "margin-right": "14.6%"
    }
  }, [_vm._v("\n        8. 报告要求Report Requirements\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "divcenter",
    staticStyle: {
      "font-size": "20px"
    }
  }, [_c('table', [_c('tr', [_vm._m(13), _vm._v(" "), _c('td', {
    staticStyle: {
      "overflow": "visible"
    },
    attrs: {
      "colspan": "1"
    }
  }, [
    [_c('el-checkbox-group', {
      attrs: {
        "disabled": _vm.isRedeoly
      },
      model: {
        value: (_vm.data.reportType),
        callback: function($$v) {
          _vm.$set(_vm.data, "reportType", $$v)
        },
        expression: "data.reportType"
      }
    }, [_c('el-checkbox', {
      attrs: {
        "label": "1"
      }
    }, [_vm._v("中文")]), _vm._v(" "), _c('el-checkbox', {
      attrs: {
        "label": "2"
      }
    }, [_vm._v("英文（加收费用）")]), _vm._v(" "), _c('el-checkbox', {
      attrs: {
        "label": "4"
      }
    }, [_vm._v("不出报告")])], 1)]
  ], 2), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('td', {
    staticStyle: {
      "overflow": "visible"
    },
    attrs: {
      "colspan": "1"
    }
  }, [
    [_c('el-checkbox-group', {
      attrs: {
        "disabled": _vm.isRedeoly
      },
      model: {
        value: (_vm.data.reportForm),
        callback: function($$v) {
          _vm.$set(_vm.data, "reportForm", $$v)
        },
        expression: "data.reportForm"
      }
    }, [_c('el-checkbox', {
      attrs: {
        "label": "1"
      }
    }, [_vm._v("电子版（默认）")]), _vm._v(" "), _c('el-checkbox', {
      attrs: {
        "label": "2"
      }
    }, [_vm._v("纸质版，需额外收取费用(自取)")]), _vm._v(" "), _c('el-checkbox', {
      attrs: {
        "label": "3"
      }
    }, [_vm._v("纸质版，需额外收取费用(快递) ")])], 1)]
  ], 2)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "overflow": "visible"
    }
  }, [_vm._v("报告标识：\n                ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "overflow": "visible"
    }
  }, [
    [_c('el-checkbox-group', {
      attrs: {
        "disabled": _vm.isRedeoly
      },
      model: {
        value: (_vm.data.cmaCnas),
        callback: function($$v) {
          _vm.$set(_vm.data, "cmaCnas", $$v)
        },
        expression: "data.cmaCnas"
      }
    }, [_c('el-checkbox', {
      attrs: {
        "label": "CNAS"
      }
    }, [_vm._v("CNAS")]), _vm._v(" "), _c('el-checkbox', {
      attrs: {
        "label": "无"
      }
    }, [_vm._v("无")]), _vm._v(" "), _c('el-checkbox', {
      attrs: {
        "label": "其他"
      }
    }, [_vm._v("其他")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.data.cmaCnas.includes('其他')),
        expression: "data.cmaCnas.includes('其他')"
      }, {
        name: "model",
        rawName: "v-model",
        value: (_vm.data.cmaCnasOther),
        expression: "data.cmaCnasOther"
      }],
      staticStyle: {
        "border-bottom": "solid red",
        "height": "20px",
        "width": "130px"
      },
      attrs: {
        "size": "60",
        "readonly": _vm.isRedeoly
      },
      domProps: {
        "value": (_vm.data.cmaCnasOther)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.data, "cmaCnasOther", $event.target.value)
        }
      }
    })], 1)]
  ], 2), _vm._v(" "), _c('td', {
    staticStyle: {
      "overflow": "visible"
    }
  }, [_vm._v("服务要求：\n                 \n                ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "overflow": "visible"
    }
  }, [
    [_c('el-radio', {
      attrs: {
        "disabled": _vm.isRedeoly,
        "label": "1"
      },
      model: {
        value: (_vm.data.serviceRequitements),
        callback: function($$v) {
          _vm.$set(_vm.data, "serviceRequitements", $$v)
        },
        expression: "data.serviceRequitements"
      }
    }, [_vm._v("正常（默认）")]), _vm._v(" "), _c('el-radio', {
      attrs: {
        "disabled": _vm.isRedeoly,
        "label": "2"
      },
      model: {
        value: (_vm.data.serviceRequitements),
        callback: function($$v) {
          _vm.$set(_vm.data, "serviceRequitements", $$v)
        },
        expression: "data.serviceRequitements"
      }
    }, [_vm._v("加急（需额外收取费用）")])]
  ], 2)]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "overflow": "visible"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("如对报告有其他要求，请说明：\n                    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.reportRemark),
      expression: "data.reportRemark"
    }],
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "readonly": _vm.isRedeoly
    },
    domProps: {
      "value": (_vm.data.reportRemark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "reportRemark", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "overflow": "visible",
      "line-height": "35px"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("报告接收方  ")]), _vm._v(" "), [_c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "1"
    },
    model: {
      value: (_vm.data.reportReceiving),
      callback: function($$v) {
        _vm.$set(_vm.data, "reportReceiving", $$v)
      },
      expression: "data.reportReceiving"
    }
  }, [_vm._v("同委托人")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "2"
    },
    model: {
      value: (_vm.data.reportReceiving),
      callback: function($$v) {
        _vm.$set(_vm.data, "reportReceiving", $$v)
      },
      expression: "data.reportReceiving"
    }
  }, [_vm._v("同代理方")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "3"
    },
    model: {
      value: (_vm.data.reportReceiving),
      callback: function($$v) {
        _vm.$set(_vm.data, "reportReceiving", $$v)
      },
      expression: "data.reportReceiving"
    }
  }, [_vm._v("同交费方")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "disabled": _vm.isRedeoly,
      "label": "4"
    },
    model: {
      value: (_vm.data.reportReceiving),
      callback: function($$v) {
        _vm.$set(_vm.data, "reportReceiving", $$v)
      },
      expression: "data.reportReceiving"
    }
  }, [_vm._v("不同于以上,请提供")])], _vm._v(" "), (_vm.data.reportReceiving == '4') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.reportReceivingOther),
      expression: "data.reportReceivingOther"
    }],
    style: (_vm.reportReceivingOtherStyle),
    attrs: {
      "size": "60",
      "readonly": (_vm.isRedeoly || _vm.data.reportReceiving !== '4')
    },
    domProps: {
      "value": (_vm.data.reportReceivingOther)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "reportReceivingOther", $event.target.value)
      }
    }
  }) : _vm._e()], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "divcenter",
    staticStyle: {
      "margin-top": "30px",
      "font-size": "23px"
    }
  }, [_vm._v("\n        9. 通用条款General Conditions\n        ")]), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "divcenter",
    staticStyle: {
      "font-size": "20px"
    }
  }, [_c('table', [_c('tr', [_vm._m(16), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "40%",
      "border-right": "0px"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.signer),
      expression: "data.signer"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "readonly": _vm.isRedeoly && _vm.data.signatureType !== 'seeEdit'
    },
    domProps: {
      "value": (_vm.data.signer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "signer", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(17), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "40%",
      "border-right": "0px"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("工业和信息化部电子第五研究所/中国赛宝实验室")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "3%"
    },
    attrs: {
      "colspan": "1"
    },
    on: {
      "click": function($event) {
        _vm.imgDialog = !(_vm.isRedeoly && _vm.data.signatureType !== 'seeEdit');
      }
    }
  }, [_vm._m(18)]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    },
    on: {
      "click": function($event) {
        _vm.imgDialog = !(_vm.isRedeoly && _vm.data.signatureType !== 'seeEdit');
      }
    }
  }, [(_vm.data.signaturelink === '') ? _c('span', {
    staticStyle: {
      "color": "#CACACD"
    }
  }, [_vm._v("请填写委托人、代理方，需要使用微信扫一扫签名(请点击此处)")]) : _vm._e(), _vm._v(" "), (_vm.data.signaturelink) ? _c('img', {
    staticStyle: {
      "width": "150px",
      "height": "45px"
    },
    attrs: {
      "src": _vm.data.signaturelink
    }
  }) : _vm._e()]), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [(_vm.data.authorizerLink === '' || _vm.data.authorizerLink === null) ? _c('span', [_vm._v(_vm._s(_vm.data.authorizer))]) : _c('img', {
    staticStyle: {
      "width": "150px",
      "height": "45px"
    },
    attrs: {
      "src": _vm.data.authorizerLink
    }
  })])]), _vm._v(" "), _c('tr', [_vm._m(20), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(" " + _vm._s(_vm.data.signaturetime))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v("日   期/Date：")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v(" " + _vm._s(_vm.data.authorizationTime))])])])]), _vm._v(" "), _c('div', {
    staticClass: "divcenter",
    staticStyle: {
      "margin-top": "40px",
      "font-size": "30px",
      "padding-left": "40%"
    }
  }, [_vm._v("\n          检验检测委托书填写说明\n        ")]), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "divcenter"
  }, [_c('el-dialog', {
    attrs: {
      "title": "授权人签名",
      "visible": _vm.imgDialog,
      "width": "900px",
      "lock-scroll": false
    },
    on: {
      "update:visible": function($event) {
        _vm.imgDialog = $event
      }
    }
  }, [_c('esign', {
    attrs: {
      "token": _vm.data.timeStamp + _vm.data.conId,
      "imgDialog": _vm.imgDialog
    },
    on: {
      "callback": _vm.receiveSignature
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "top": "0",
      "z-index": "999",
      "width": "100%",
      "background-color": "#3e4753",
      "color": "rgb(218, 213, 213)",
      "ont-size": "14px",
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "1000px",
      "min-width": "1000px",
      "margin": "0 auto",
      "font-size": "23px",
      "margin-top": "10px",
      "margin-bottom": "15px"
    }
  }, [_c('span', [_vm._v("工业和信息化部电子第五研究所/中国赛宝实验室")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("检验检测委托书")]), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "-40px",
      "margin-right": "150px"
    },
    style: (_vm.data.signatureType === "see" ? "display:block" : "display:none")
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://fw.ceprei.com/service/conSgin/downPDF?timeStamp=" + _vm.data.timeStamp + "&conId=" + _vm.data.conId + "&fileName=" + _vm.data.serialNumber + ".pdf"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    }
  }, [_vm._v(" 下载PDF")])], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "-40px"
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.isRedeoly && _vm.data.signatureType !== 'seeEdit',
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.sava('暂存');
      }
    }
  }, [_vm._v(" 暂存 ")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-right": "-150px",
      "margin-top": "-40px"
    }
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.isRedeoly && _vm.data.signatureType !== 'seeEdit',
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submit('提交');
      }
    }
  }, [_vm._v(" 提交 ")])], 1), _vm._v(" "), _vm._m(23)])]), _vm._v(" "), _vm._m(24)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("序号"), _c('br'), _vm._v("Serial Number ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "width": "20%"
    }
  }, [_vm._v(" 样品名称"), _c('br'), _vm._v("Product")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "width": "20%"
    }
  }, [_vm._v("样品型号"), _c('br'), _vm._v("Model No. ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "width": "13%"
    }
  }, [_vm._v(" 样品规格"), _c('br'), _vm._v("Specification ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "width": "13%"
    }
  }, [_vm._v("样品描述"), _c('br'), _vm._v("Description ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "width": "8%"
    }
  }, [_vm._v(" 商标"), _c('br'), _vm._v("Trademark")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "width": "8%"
    }
  }, [_vm._v(" 数量"), _c('br'), _vm._v("Quantity")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("   "), _c('span', {
    staticClass: "color"
  }, [_vm._v(" 样品寄送方式： ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "font-size": "18px",
      "color": "red"
    }
  }, [_vm._v("    试验后样品处理（如不勾选，默认销毁）："), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "rowspan": "2",
      "width": "40%"
    }
  }, [_vm._v("检验检测依据"), _c('br'), _vm._v(" Testing Basis")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("检验检测项目"), _c('br'), _vm._v(" Test Items")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("检验检测条件及要求 "), _c('br'), _vm._v("Technical Conditions")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("附件("), _c('span', {
    staticStyle: {
      "font-size": "13px",
      "color": "red",
      "font-weight": "bold"
    }
  }, [_c('i', {
    staticClass: "el-icon-warning"
  }), _vm._v(":重名只会上传成功一个,后上传的会覆盖以前上传的,单个文件最大10M")]), _vm._v(")")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "overflow": "visible"
    },
    attrs: {
      "colspan": "1"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("报告形式：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "overflow": "visible"
    },
    attrs: {
      "colspan": "1"
    }
  }, [_c('span', {
    staticClass: "color"
  }, [_vm._v("报告类别：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "divcenter",
    staticStyle: {
      "font-size": "21px"
    }
  }, [_c('p', [_vm._v("a.委托人对所提供资料和样品来源的真实性和合法性负责；当生产企业与委托人不同，或由代理方填表时，本实验室不承担相关纠纷责任。")]), _vm._v(" "), _c('p', [_vm._v("b.若委托人需将检验检测报告用作仲裁或法律诉讼证据，必须在委托书中事先声明，并承担本实验室因配合司法机关取证而产生的人力、物力及交通等费用。")]), _vm._v(" "), _c('p', [_vm._v("c.此委托书是样品检验检测的依据，是客户获取报告和取回样品的凭证，填表人须确认所填信息真实、完整、准确，应对所填信息负责。如因信息错误导致已出报告的更改，或补充检验检测，须收回原报告，且酌情收取报告更改费或补充检验检测费用。")]), _vm._v(" "), _c('p', [_vm._v("d.本实验室按照委托书及相关标准要求开展检验检测活动，本委托检验检测的数据、结果仅适用于收到的样品，不代表委托人/生产企业其他同批次或同类产品质量。委托人不得利用报告从事虚假宣传和其他违法活动。")]), _vm._v(" "), _c('p', [_vm._v("e.依此委托书进行检验检测期间，如委托人/代理方提出终止检验检测，仍须承担已完成检验检测项目所产生的费用；如委托人提出变更检验检测要求，须重新提交委托书，实验室将以新的委托书作为最终依据并重新核算检验检测费用。")]), _vm._v(" "), _c('p', [_vm._v("f.为保证检验检测和技术服务的质量，委托人应尽可能详细的提供检验检测所需的各种资料和辅助工具（或配件），包括检验检测方案、所需的各种辅助工具（或配件）以及注意事项等。")]), _vm._v(" "), _c('p', [_vm._v("g.委托人如对检验检测样品保护有特别要求的，需在填委托书时特别提出。")]), _vm._v(" "), _c('p', [_vm._v("h.由于未预料的工作量增加不能按要求时间完成或因设备、人员或环境条件等暂时性原因而不具备能力开展委托的项目，我方可选择分包试验。若委托人不同意，请注明。")]), _vm._v(" "), _c('p', [_vm._v("i.本实验室对检验检测过程中获得或产生的客户有关信息和客户非公开性的资料予以保密。")]), _vm._v(" "), _c('p', [_vm._v("j.委托人若对报告有异议，需在收到报告之日起15个工作日内书面提出，否则视为接受；试验费用应在约定的时间内支付，逾期将向委托人收取违约金。")]), _vm._v(" "), _c('p', [_vm._v("k.如委托任务涉及赛宝CE认证申请，请填写委托合同中附表《CE认证申请信息表》的内容。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "colspan": "1"
    }
  }, [_c('span', [_vm._v("委托人/代理方名称："), _c('br'), _vm._v("Client / Agent")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v("实验室名称："), _c('br'), _vm._v("Laboratory")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "color"
  }, [_vm._v("经办人签章："), _c('br'), _vm._v("Stamp / Signature：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v("经办人签章："), _c('br'), _vm._v("Stamp / Signature：")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "colspan": "1"
    }
  }, [_c('span', [_vm._v("日   期/Date：")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "divcenter",
    staticStyle: {
      "font-size": "21px"
    }
  }, [_c('p', [_vm._v(" 1 此文本用来统一本整机板块检验检测委托书形式；")]), _vm._v(" "), _c('p', [_vm._v("2生产者对应于制造商；生产企业对应于生产单位；")]), _vm._v(" "), _c('p', [_vm._v("3若有样品其他信息，如样品生产日期等，可在“型号规格/样品描述”栏目中填写；")]), _vm._v(" "), _c('p', [_vm._v("4 为确保委托信息的完整性，填写的信息不能简写，应以实际内容完整填写；")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "divcenter",
    staticStyle: {
      "font-size": "21px"
    }
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "float": "left",
      "margin-left": "18%",
      "margin-top": "-65px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "70px",
      "height": "70px"
    },
    attrs: {
      "src": require("../../assets/favicon.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "fixed",
      "bottom": "0",
      "z-index": "999",
      "width": "100%",
      "background-color": "#3e4753",
      "color": "rgb(218, 213, 213)",
      "font-size": "14px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50%",
      "margin": "0 auto",
      "padding-top": "10px",
      "min-width": "730px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "6px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.ceprei.com/index.html"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://ca.ceprei.com/_nuxt/img/logo2-default.73cb0f3.png"
    }
  })])]), _vm._v(" "), _c('p', [_vm._v("Copyright © 2015. 中国赛宝实验室 All rights reserved.  "), _c('i', {
    staticClass: "icon-home"
  }), _vm._v(" 广州市增城区朱村街朱村大道西78号  CEPREI-ZB-HT01-202102")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34a7c6d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/consignation/emailConSign.vue
// module id = 1199
// module chunks = 10